import IncomingMessageAI from './IncomingMessageAI';
import IncomingMessageICP from './IncomingMessageICP';
import IncomingMessageJob from './IncomingMessageJob';

type SectionMoveHandler = (sectionKey: string, items: string[]) => Promise<void> | void;
type SelectSuggestionHandler = (text: string, sectionKey: string) => Promise<void> | void;
type AddFieldSuggestionHandler = (fieldName: string, suggestions: string[]) => Promise<void> | void;

interface IncomingMessageProps {
    chat: any;
    message: any;
    isLoading?: boolean;
    isFromJob?: boolean;
    componentType?: 'job' | 'icp' | 'create' | string;
    setLastMessageId: (id: number) => void;
    handleSendMessage: (options: any, initialAnswer: any) => void;
    setEnableGenerateResponse: (flag: boolean) => void;
    setLastQuestionStep?: (step: any) => void;
    onSelectSuggestion?: SelectSuggestionHandler;
    onAddFieldSuggestion?: AddFieldSuggestionHandler;
    onMoveSuggestions?: SectionMoveHandler;
    isLastMessage?: boolean;
}

/**
 * IncomingMessage - Router Component
 * Delegates to specialized components based on chat type
 */
const IncomingMessage = (props: IncomingMessageProps) => {
    const { componentType = 'job' } = props;

    // Route to ChatWithAI (General chat/Job creation)
    const isGeneralChat = !componentType || componentType === 'general' || componentType === 'create';
    if (isGeneralChat) {
        return <IncomingMessageAI {...props} />;
    }

    // Route to ChatWithICP (Ideal Candidate Profile)
    if (componentType === 'icp') {
        return <IncomingMessageICP {...props} />;
    }

    // Route to ChatWithJob (Job Description Editing) - default
    return <IncomingMessageJob {...props} />;
};

export default IncomingMessage;
